<div class="parent">
  <div class="cet-loan-card-container l2-tm">
    <ng-container *ngIf="amountModify">
      <p class="gray">
        <strong>{{ "LoanCard.Amount" | translate }}</strong>
      </p>
      <div class="amount-container">
        <p style="font-size: 20px">
          <strong class="Saudi_Riyal">
            <small>{{ "Currency.SAR" | translate }}</small>
            <span style="min-width: 0px; display: inline-block"></span>
            {{ amount || 0 | currencyFormat }}
          </strong>
        </p>
        <p (click)="modifyAmount()" class="colored underline" style="display: flex; align-items: center">
          <strong>{{ "Buttons.Modify" | translate }}</strong>
          <span style="min-width: 5px; display: inline-block"></span>
          <img src="assets/images/edit.webp" alt="modify" style="width: 20px" />
        </p>
      </div>
    </ng-container>
    <div class="tenure-container" *ngIf="tenures.length>0">
      <p class="gray">
        <strong>{{ "LoanCard.TenureAndInstallment" | translate }}</strong>
      </p>
      <div style="width: 100%; text-align: center" *ngIf="!tenures">
        <img
          src="assets/images/rolling.webp"
          alt="loading"
          style="width: 30px"
        />
      </div>
      <p class="gradient" *ngIf="tenures">
        <span>grad</span>
      </p>


      <app-rotary-selector
        style="
          width: 100%;
          display: flex;
          justify-content: center;
          margin-block: 16px;
        "
        [itemWidth]="60"
        (selected)="select(tenures[$event-1])"
      >
        <div
          class="tenure-item"
          *ngFor="let tenure of tenures; let i = index"
          items
          [style.width]="60"
          [attr.selection-identifier]="i"
        >
          <div class="time">
            <span>{{ tenure.Tenure }}</span>
            <span>{{ "TimeUnits.Mon" | translate }}</span>
          </div>
          <div class="amount Saudi_Riyal">
            <span>{{ tenure.InstallmentAmount }}</span>
            <span>{{ "Currency.SAR" | translate }}</span>
          </div>
        </div>
      </app-rotary-selector>
    </div>
      <div class="tenure-installment" *ngIf="tenures.length==0">
        <div class="tenure">
          <p>
            <strong>{{ "OfferPage.Tenure" | translate }}</strong>
          </p>
          <p>
            <strong>{{ offer?.Tenure }} {{ "TimeUnits.Mon" | translate }}</strong>
          </p>
        </div>
        <div class="installment">
          <p>
            <strong>{{ "OfferPage.Installment" | translate }}</strong>
          </p>
          <p class="Saudi_Riyal">
            <small>{{ "Currency.SAR" | translate }} </small>
            <strong>{{ offer?.InstallmentAmount | currencyFormat}}</strong>
          </p>
        </div>
    </div>
  </div>
</div>
